module.exports = __webpack_public_path__ + "media/images/patent/y_10-6bd61fd6786effa950ffc57b1db5acc5.jpg";